import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import Sidebar from "./components/Sidebar";
import Navbar from "./components/Navbar";
import Table from "./components/ui/Table";
const baseUrl = process.env.REACT_APP_API_BASE_URL;

const Settings = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [editingIndex, setEditingIndex] = useState(null);
  const [formData, setFormData] = useState({
    year: "",
    coin: "",
    baseRate: "",
    refallRate: "",
  });

  const token = localStorage.getItem("token");

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${baseUrl}/setting/yearly-total-supply`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const result = await response.json();
      if (result.status && result.data) {
        setData(result.data);
      } else {
        throw new Error(result.message);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (index) => {
    setEditingIndex(index);
    setFormData(data[index]);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSave = async () => {
    const current = data[editingIndex];
    const supplyId = current._id || current.id; // Ensure correct ID field

    try {
      const response = await fetch(`${baseUrl}/setting/yearly-total-supply/${supplyId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(formData),
        }
      );
      const result = await response.json();
      if (!response.ok) throw new Error(result.message || "Update failed");

      const updated = [...data];
      updated[editingIndex] = formData;
      setData(updated);
      setEditingIndex(null);
      toast.success("Supply updated successfully!");
    } catch (err) {
      toast.error(err.message);
    }
  };

  const handleAddNew = async () => {
    try {
      const response = await fetch(`${baseUrl}/setting/yearly-total-supply`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(formData),
        }
      );
      const result = await response.json();
      if (!response.ok) throw new Error(result.message || "Add failed");

      setData([...data, result.data]);
      setFormData({ year: "", coin: "", baseRate: "", refallRate: "" });
      toast.success("New supply added successfully!");
    } catch (err) {
      toast.error(err.message);
    }
  };

  const columns = [
    { key: "year", header: "Year" },
    { key: "coin", header: "Total Coins", render: (item) => item.coin.toLocaleString() },
    { key: "baseRate", header: "Base Rate" },
    { key: "refallRate", header: "Referral Rate" },
    {
      key: "actions",
      header: "Actions",
      render: (item) => {
        const index = data.findIndex((d) => d === item);
        return (
          <button
            className="bg-emerald-600 text-white px-3 py-1 rounded hover:bg-emerald-700 transition"
            onClick={() => handleEdit(index)}
          >
            Edit
          </button>
        );
      },
    },
  ];

  return (
    <div className="flex flex-col md:flex-row bg-gray-900 min-h-screen">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <Navbar />
        <div className="p-6">
          <h2 className="text-3xl font-bold mb-6 text-white">Yearly Coin Supply Settings</h2>

          {/* Form */}
          <div className="bg-gray-800 p-6 rounded shadow mb-6">
            <h3 className="text-xl font-semibold mb-4 text-white">
              {editingIndex !== null ? "Edit Supply" : "Add New Supply"}
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <input
                type="number"
                name="year"
                placeholder="Year"
                value={formData.year}
                onChange={handleChange}
                className="border border-gray-600 p-2 w-full bg-gray-700 text-white rounded"
              />
              <input
                type="number"
                name="coin"
                placeholder="Total Coins"
                value={formData.coin}
                onChange={handleChange}
                className="border border-gray-600 p-2 w-full bg-gray-700 text-white rounded"
              />
              <input
                type="number"
                step="0.01"
                name="baseRate"
                placeholder="Base Rate"
                value={formData.baseRate}
                onChange={handleChange}
                className="border border-gray-600 p-2 w-full bg-gray-700 text-white rounded"
              />
              <input
                type="number"
                step="0.01"
                name="refallRate"
                placeholder="Referral Rate"
                value={formData.refallRate}
                onChange={handleChange}
                className="border border-gray-600 p-2 w-full bg-gray-700 text-white rounded"
              />
            </div>
            <div className="mt-4">
              <button
                onClick={editingIndex !== null ? handleSave : handleAddNew}
                className="bg-brand text-white px-4 py-2 rounded hover:bg-brand-dark transition"
              >
                {editingIndex !== null ? "Save Changes" : "Add Supply"}
              </button>
            </div>
          </div>

          {error && <p className="text-red-400 mb-4">{error}</p>}

          <Table
            columns={columns}
            rows={data}
            rowKey={(item) => item._id || item.id}
            loading={loading}
            emptyMessage="No supply records found."
          />
        </div>
      </div>
    </div>
  );
};

export default Settings;
